(function() {
  'use strict';

  // Shared by all instances of the directive, so the page loads the script once.
  let scriptLoad = null;

  angular.module('ringbaPortal').directive('systemsStatus', systemsStatus);

  function systemsStatus(

  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      scope: {}, // Use isolated scope
      controller: SystemsStatusController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/systems-status/systems-status.view.html'
    };
    return directive;

    function SystemsStatusController(
      $filter,
      $interval,
      $scope,
      statusPage
    ) {
      'ngInject';

      const vm = this;
      let timer,
        sp = false,
        isDestroyed = false;

      vm.$onInit = onInit;

      function onInit() {
        // A script that fails to load leaves the widget empty.
        loadStatusPageScript(statusPage.cdn).then(_startStatusChecks, angular.noop);
      }

      function _startStatusChecks() {
        if (isDestroyed || !window.StatusPage || typeof window.StatusPage.page !== 'function') {
          return;
        }
        sp = new window.StatusPage.page({ page: statusPage.id });
        getStatus();
        _setIntervalToCheckStatus();
      }

      function getStatus() {
        if (sp) {
          sp.status({
            // Statuspage answers outside the digest, so the view needs one scheduled to show the response.
            success: response => $scope.$evalAsync(() => _handleStatusResponse(response))
          });
        }
      }

      function _handleStatusResponse(response) {
        // adds the text description
        vm.status = $filter('translate')(response.status.description);
        // appends the status indicator as a class name so we can use the right color for the status light thing
        vm.statusClass = 'green_status';
        switch (response.status.indicator) {
        case 'none':
          vm.statusClass = 'green_status';
          break;
        case 'minor':
          vm.statusClass = 'light_yellow_status';
          break;
        case 'major':
          vm.statusClass = 'yellow_status';
          break;
        case 'critical':
          vm.statusClass = 'red_status';
          break;
        default:
          vm.statusClass = 'green_status';
        }
      }

      function _setIntervalToCheckStatus() {
        timer = $interval(getStatus, 30000);
      }

      function _onScopeDestroy() {
        isDestroyed = true;
        $interval.cancel(timer);
      }

      $scope.$on(
        '$destroy',
        _onScopeDestroy
      );


    }
  }

  function loadStatusPageScript(url) {
    if (window.StatusPage) {
      return Promise.resolve();
    }
    if (!scriptLoad) {
      scriptLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return scriptLoad;
  }

})();
